import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g data-name=\"Icon - Expand\"><g stroke=\"#f0f0f0\" data-name=\"Rechteck 118\"><rect width=\"24\" height=\"24\" stroke=\"none\" rx=\"4\"></rect><rect width=\"23\" height=\"23\" x=\".5\" y=\".5\" fill=\"none\" rx=\"3.5\"></rect></g><path fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M10.093 6.84 15.25 12l-5.157 5.16\" data-name=\"Pfad 33\"></path></g>", 1)
  ])))
}
export default { render: render }